import { Country } from '../../lib/country-state';
import { getCountriesByPreference } from '../Charger/utils';
import { FeePackageFrontendType, PackageType } from '../../stores/types/feePackage.interface';

/**
 * Builds a formatted list of countries for phone number country code selection.
 *
 * Special Handling:
 * - Canada (CA) and United States (US) are combined into a single dropdown option.
 * - This combined option appears under Canada's entry (CA), using a dual-flag display.
 */
export const getPhoneCountryList = (isoCountryCode: string | undefined) => {
  const result = Country.getAllCountries();
  const US = 'US';
  const CA = 'CA';
  return (
    result
      // Exclude the US entry to avoid duplicate display of flag in the dropdown
      .filter((obj: any) => obj.isoCode !== US)
      .map((obj: any) => ({
        ...obj,
        // Use a special ID for the CA-US combined entry
        id: obj.isoCode === CA ? 'CA-US' : obj.isoCode,
        // Display dual flags for CA-US; otherwise use the country's own flag
        flagAndCode:
          obj.isoCode === CA ? `${'🇨🇦🇺🇸'} +${obj.phonecode}` : `${obj.flag} +${obj.phonecode}`,
        // Mark CA as selected if the company's country is either CA or US;
        // otherwise, match selection by exact isoCode
        selected:
          isoCountryCode === US || isoCountryCode === CA
            ? obj.isoCode === CA
            : obj.isoCode === isoCountryCode,
      }))
  );
};

export const getCountryList = (isoCountryCode: string | undefined) => {
  const countries = Country.getAllCountries();
  const result = getCountriesByPreference(countries);
  return result.map((obj: any) => ({
    ...obj,
    id: obj.isoCode,
    flagAndCode: `${obj.flag} +${obj.phonecode}`,
    selected: obj.isoCode === isoCountryCode,
  }));
};

export enum countryCodes {
  US = 'US',
  CA = 'CA',
  JM = 'JM',
  BB = 'BB',
}

export const frontendLabelMap: Record<PackageType, FeePackageFrontendType> = {
  [PackageType.FLEX_PLAN]: FeePackageFrontendType.FLEX,
  [PackageType.BASIC_PLAN]: FeePackageFrontendType.BASIC,
  [PackageType.PRO_PLAN]: FeePackageFrontendType.PRO,
  [PackageType.ELA]: FeePackageFrontendType.ELA,
  [PackageType.ESSENTIALS]: FeePackageFrontendType.ESSENTIALS,
  [PackageType.ESSENTIALS_PLUS]: FeePackageFrontendType.ESSENTIALS_PLUS,
  [PackageType.NONE]: FeePackageFrontendType.NONE,
};
